import axios from "axios";

const uploadImage = async (file, setImage) => {
  //preparing image data
  let data = new FormData();
  data.append("file", file);
  data.append("upload_preset", "ekd9tdus");

  try {
    const res = await axios.post(
      "https://api.cloudinary.com/v1_1/sumailcodes/image/upload",
      data
    );
    setImage(res.data.url);
  } catch (err) {
    console.log(err);
  }
};

export default uploadImage;

//   fetch(" https://api.cloudinary.com/v1_1/sumailcodes/image/upload", {
//     method: "post",
//     body: data,
//   })
//     .then((resp) => resp.json())
//     .then((data) => {
//         setImage(data.url);

//     })
//     .catch((err) => console.log(err));
